import Vue from 'vue';

const tokenStorageKey = 'authToken';

export default {
  setHeaders(request) {
    if (this.shouldBeAuthenticated(request)) {
      request.headers.set('Authorization', `Bearer ${this.getToken()}`);
    }
    request.headers.set('ContentType', 'application/json');
    return request;
  },
  refreshToken() {
    return false;
  },
  getToken() {
    return window.$cookies.get(tokenStorageKey);
  },
  setToken(token, rememberMe) {
    if (this.getToken()) {
      this.removeToken();
    }

    let cookieTime = '0';

    if (rememberMe == 'yes') {
      cookieTime = '30d';
    }

    window.$cookies.set(tokenStorageKey, token, cookieTime);
  },
  removeToken() {
    window.$cookies.remove(tokenStorageKey);
  },
  /**
   * Check if user is superAdmin
   *
   * @param user
   * @returns {boolean}
   */
  isGrantedSuperAdmin(user) {
    if (user && user.roles.indexOf('ROLE_ADMIN') !== -1) {
      return true;
    }
    console.warn('User is not granted superAdmin !');
    return false;
  },
  isAuthenticated() {
    return this.getToken();
  },
  shouldBeAuthenticated(request) {
    const method = request.method;
    if (method === 'post') {
      switch (request.url) {
        case 'users':
        case 'users/login':
        case 'users/reset/password':
          return false;
        default:
          return true;
      }
    } else if (method === 'get') {
      switch (request.url) {
        case 'login_check':
          return false;
        default:
          return true;
      }
    }
    return true;
  },
  handle401() {
    return false;
  },
};



// WEBPACK FOOTER //
// ./src/services/AuthService.js